import { combineReducers } from 'redux';

import * as State from '../actions/types';
import { Type } from '../actions/utils';

import initialState from './initial';

export const lastMfaCodeSentAt = (state: any = initialState.app.lastMfaCodeSentAt, action: any) => {
  switch (action.type) {
    case Type.LAST_MFA_CODE_SENT_AT:
      return action.payload;
    case State.actionSucceeded(Type.LOGOUT):
      return initialState.app.lastMfaCodeSentAt;
    default:
      return state;
  }
};

export const redirectToOffer = (state: any = initialState.app.redirectToOffer, action: any) => {
  switch (action.type) {
    case Type.ADD_REDIRECT_TO_OFFER:
      return action.payload;
    case Type.REMOVE_REDIRECT_TO_OFFER:
      return null;
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
    case State.actionSucceeded(Type.LOGOUT):
      return initialState.app.redirectToOffer;
    default:
      return state;
  }
};

export const redirectToOfferOrder = (state: any = initialState.app.redirectToOfferOrder, action: any) => {
  switch (action.type) {
    case Type.ADD_REDIRECT_TO_OFFER_ORDER:
      return action.payload;
    case Type.REMOVE_REDIRECT_TO_OFFER_ORDER:
      return null;
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
    case State.actionSucceeded(Type.LOGOUT):
      return initialState.app.redirectToOfferOrder;
    default:
      return state;
  }
};

export const redirectToEmailConfirm = (state: any = initialState.app.redirectToEmailConfirm, action: any) => {
  switch (action.type) {
    case Type.APP_REDIRECT_TO_EMAIL_CONFIRM_REMOVE:
      return null;
    case Type.APP_REDIRECT_TO_EMAIL_CONFIRM_ADD:
      return action.payload;
    default:
      return state;
  }
};

export const onboardStep = (state: any = initialState.app.onboardStep, action: any) => {
  switch (action.type) {
    case Type.UPDATE_ONBOARD_STEP:
      return action.payload;
    case State.actionSucceeded(Type.LOGOUT):
      return initialState.app.onboardStep;
    default:
      return state;
  }
};

export const offerInvestReferrer = (state: any = initialState.app.offerInvestReferrer, action: any) => {
  switch (action.type) {
    case Type.ADD_OFFER_INVEST_REFERRER:
      return action.payload;
    case Type.REMOVE_OFFER_INVEST_REFERRER:
      return initialState.app.offerInvestReferrer;
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
    case State.actionSucceeded(Type.LOGOUT):
      return initialState.app.offerInvestReferrer;
    default:
      return state;
  }
};

export const accountApplicationCategoryViewList = (
  state: any = initialState.app.accountApplicationCategoryViewList,
  action: any,
) => {
  switch (action.type) {
    case Type.SET_ACCOUNT_APPLICATION_CATEGORY_VIEW_LIST:
      return action.payload;
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
    case State.actionSucceeded(Type.LOGOUT):
      return initialState.app.accountApplicationCategoryViewList;
    default:
      return state;
  }
};

export const redirectToSummaryAfterAccountSubmit = (
  state = initialState.app.redirectToSummaryAfterAccountSubmit,
  action: any,
) => {
  switch (action.type) {
    case Type.ADD_REDIRECT_TO_SUMMARY_AFTER_ACCOUNT_SUBMIT:
      return true;
    case Type.REMOVE_REDIRECT_TO_SUMMARY_AFTER_ACCOUNT_SUBMIT:
      return false;
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
    case State.actionSucceeded(Type.LOGOUT):
      return initialState.app.redirectToSummaryAfterAccountSubmit;
    default:
      return state;
  }
};

export const redirectToCompleteAccountAfterSubmit = (
  state = initialState.app.redirectToCompleteAccountAfterSubmit,
  action: any,
) => {
  switch (action.type) {
    case Type.ADD_REDIRECT_TO_COMPLETE_ACCOUNT_AFTER_SUBMIT:
      return true;
    case Type.REMOVE_REDIRECT_TO_COMPLETE_ACCOUNT_AFTER_SUBMIT:
      return false;
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
    case State.actionSucceeded(Type.LOGOUT):
      return initialState.app.redirectToCompleteAccountAfterSubmit;
    default:
      return state;
  }
};

export const redirectToLinkAccount = (state = initialState.app.redirectToLinkAccount, action: any) => {
  switch (action.type) {
    case Type.ADD_REDIRECT_TO_LINK_ACCOUNT:
      return true;
    case Type.REMOVE_REDIRECT_TO_LINK_ACCOUNT:
      return false;
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
    case State.actionSucceeded(Type.LOGOUT):
      return initialState.app.redirectToLinkAccount;
    default:
      return state;
  }
};

export default combineReducers({
  lastMfaCodeSentAt,
  redirectToOffer,
  redirectToOfferOrder,
  redirectToEmailConfirm,
  onboardStep,
  offerInvestReferrer,
  accountApplicationCategoryViewList,
  redirectToSummaryAfterAccountSubmit,
  redirectToCompleteAccountAfterSubmit,
  redirectToLinkAccount,
});
